<div class="proposition">
  <crnt-icon icon="gift" size="large" class="d-block" />
  <div class="proposition__text">
    <p class="proposition__title">
      {{ rendering() | scFieldValue: 'PropositionBoxTitle' }}
    </p>
    <p class="proposition__description">
      {{ rendering() | scFieldValue: 'PropositionBoxDescription' }}
    </p>

    @if (rendering().fields.PropositionMoreInfoModal) {
      <crnt-button
        class="proposition__info"
        [fullWidth]="true"
        (click)="openMoreInfoModal()"
      >
        {{ rendering() | scFieldValue: 'PropositionMoreInfoText' }}
      </crnt-button>
    }
  </div>
</div>
